export default __webpack_public_path__ + "static/media/subBg.2a1be156.jpg";